import React from 'react';
import {Box, HStack, Text} from '@chakra-ui/react';
import {Trans, useTranslation} from 'react-i18next';
import {imageOptimisee} from '../mediatheque/optimisation';
import {LogoFranceFrais} from '@/components/svg/LogoFranceFrais';

export const PartieGaucheConnexion: React.FC = () => {
  const baseMediaUrl = import.meta.env['VITE_MEDIA_URL'];
  const imageUrl = imageOptimisee(
    `${baseMediaUrl}/metiers/FFKeyImage.jpg`,
    1600,
    {height: 2400, gravity: '0.5,0.5'},
  );
  const {t} = useTranslation('common');

  return (
    <Box
      position='relative'
      height='100vh'
      width='100%'
      display={{base: 'none', md: 'block'}}
      backgroundImage={`url(${imageUrl})`}
      backgroundPosition='bottom 15% left 55%'
      backgroundSize='150%'
    >
      <HStack
        position='absolute'
        top={8}
        left={8}
        spacing={4}
        align='center'
      >
        <LogoFranceFrais
          width='8em'
          height='auto'
          color='blue.main'
        />
        <Text
          fontSize='xl'
          color='blue.main'
          fontWeight='700'
          lineHeight='1.3'
        >
          <Trans
            t={t}
            i18nKey='branding.slogan'
            components={{br: <br />}}
          />
        </Text>
      </HStack>
    </Box>
  );
};
